import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface FormActionsProps {
  submitLabel: string;
  backTo?: string;
  backLabel?: string;
}

/** Кнопки внизу формы: сохранить и опциональная ссылка «Назад» */
export const FormActions: React.FC<FormActionsProps> = ({
  submitLabel,
  backTo,
  backLabel,
}) => (
  <div className="d-flex flex-wrap gap-2 mt-3">
    <Button variant="primary" type="submit">
      {submitLabel}
    </Button>
    {backTo && backLabel && (
      <Link to={backTo} className="btn btn-outline-secondary">
        ← {backLabel}
      </Link>
    )}
  </div>
);

export default FormActions;
